<template>
<div>
    <b-row>
        <b-col class="col-lg-6">
            <div style="float:left;" class="custom-search d-flex justify-content-end">
                <b-form-group>
                    <div class="d-flex align-items-center">
                        <label for="request-date">{{ $t('accountingEndOfDayTransferReport.date') }}</label>
                        <b-form-group>
                            <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" :placeholder="$t('accountingEndOfDayTransferReport.date')" size="sm" v-model="requestDate" class="mb1" defaultDate:null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" @input="getEndOfDayTransferReportList()" />
                        </b-form-group>
                    </div>
                </b-form-group>
            </div>
        </b-col>
        <b-col class="d-flex justify-content-end col-lg-6 mb-2">
            <b-button style="float:right;" class="mr-05" size="sm" variant="outline-primary" @click="getEndOfDayTransferReportList()">{{ $t('others.list') }}</b-button>
        </b-col>
    </b-row>
    <!-- table -->
    <vue-good-table id="accountingEndOfDayTransferReportTable" ref="accountingEndOfDayTransferReportTable" :columns="columns" :rows="rows" styleClass="vgt-table condensed tableSize" :search-options="{
        enabled: true,
        externalQuery: searchTerm,
      }" :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field === 'accountingTransactionType'" class="text-nowrap">
                {{ $t('accountingEndOfDayTransferReport.accounting_transaction_type') }}
            </span>
            <span v-else-if="props.column.field === 'transferedRecordCount'" class="text-nowrap">
                {{ $t('accountingEndOfDayTransferReport.transfered_record_count') }}
            </span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">

            <span v-if="props.column.field === 'accountingTransactionType'">
                <span>{{ props.row.accountingTransactionType }}</span>
            </span>
            <span v-else-if="props.column.field === 'transferedRecordCount'">
                <span>{{ props.row.transferedRecordCount }}</span>
            </span>
            <!-- Column: Process -->
        </template>
    </vue-good-table>
</div>
</template>

<script>
//eslint-disable
export default {
    props: {},
    data() {
        return {
            dir: false,
            columns: [{
                    label: this.$t('accountingEndOfDayTransferReport.accounting_transaction_type'),
                    field: `accountingTransactionType`,
                },
                {
                    label: this.$t('accountingEndOfDayTransferReport.transfered_record_count'),
                    field: `transferedRecordCount`,
                },
            ],
            rows: [],
            searchTerm: '',
            requestDate: null
        }
    },
    mounted() {
        this.requestDate = new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().slice(0, 10), // Creates a new Date object based on today
        this.getEndOfDayTransferReportList()
    },
    methods: {
        getEndOfDayTransferReportList() {
            this.rows = []
            const data = {
                requestDate: this.requestDate
            }
            const controller = {
                name: 'Report',
                actionName: 'GetEndOfDayTransferReport'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.rows = response.data.endOfDayTransferLogList
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
    },
}
</script>

<style lang="scss">
.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
</style>
